import client from '@/api/clientLoggable';
import { Direction, DirectionDetectionPhase } from '@/services/facetracker';
import getAuthHeader from '@/util/getAuthHeader';

export default {
  /** セッション開始 */
  async start() {
    const ret = await client.post<StartResponse>('/face_action_animations', null, {
      headers: getAuthHeader()
    });
    return ret;
  },

  /** キャリブレーション実行 */
  async calibrate(req: Request) {
    const ret = await client.post<CalibrateResponse>(`/face_action_animations/${req.id}/calibrate`, req, {
      headers: getAuthHeader()
    });
    return ret;
  },

  /** 自撮り撮影 */
  async takeSelfie(req: Request) {
    const ret = await client.post<void>(`/face_action_animations/${req.id}/selfie`, req, {
      headers: getAuthHeader()
    });
    return ret;
  },

  /** 首振り方向初期化 */
  async initializeDirections(id: number) {
    const ret = await client.get<InitializeDirectionResponse>(`/face_action_animations/${id}/directions`, {
      headers: getAuthHeader()
    });
    return ret;
  },

  /** 顔方向検知 */
  async detectFace(request: CheckDirectionRequest) {
    // const config: AxiosRequestConfig = {
    //   timeout: 5000
    // };
    const ret = await client.post<Response>(`/face_action_animations/${request.id}/detect_face_directions`, request, {
      headers: getAuthHeader(),
      timeout: 5000
    });
    return ret;
  }
};

export interface Request {
  imageBase64: string;
  id: number;
}

export interface Response {
  result: CheckDirectionStatus;
}

export interface InitializeDirectionsRequest {
  id: number;
}

export interface InitializeDirectionResponse {
  directions: DirectionToTrack[];
}

export enum CheckDirectionStatus {
  None = 0,
  Success = 1,
  Ignore = 2,
  DifferentDirection = 3,
  FaceNotFound = 4,
  InError = 99
}

export interface CheckDirectionRequest {
  imageBase64: string;
  id: number;
  phase: DirectionDetectionPhase;
}

export interface Face {
  pose: Pose;
  position: number[];
}

export interface Pose {
  pitch: number;
  roll: number;
  yaw: number;
}

export interface StartResponse {
  faceActionAnimationId: number;
}

export interface DirectionToTrack {
  index: number;
  direction: Direction;
}

export interface CalibrateResponse {
  isCompleted: boolean;
  currentCount: number;
  maxCount: number;
}
